const shippingTypesModel = vm => ({
  title: vm.$gettext('Shipping Types'),
  endpoint: 'shipping-types',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: false,
      editable: true
    }
  ],
  filters: ['id', 'name', 'description']
})

export default shippingTypesModel
